/**
 * The right panel's top strip.
 *
 * No bottom border, matching t3code: its `WorkspacePageHeader` and its right
 * panel tab bar are both height + padding + flex and nothing else. A horizontal
 * rule under a strip reads as "a bar sitting above content", which is exactly
 * what made this panel look like a drawer under the breadcrumb rather than the
 * third column. The seam that should be visible between columns is the vertical
 * one, drawn by the panel's own `border-l`.
 *
 * Extracted so the guard in `columnSeams.test.ts` can assert it without
 * mounting React.
 */
export const RIGHT_SIDEBAR_SHELL_HEADER_CLASS =
  "flex min-h-13 items-center gap-1 bg-card pl-2 pr-3 sm:min-h-0";
